import React from "react";
import { displayFalsyValue, MetadataRenderer, sortMetadataEntries } from "./DisplayHelpers";

export default class DataTransformer {
    /**
     * Transforms raw data object into renderable format with falsy value handling
     */
    static transformToRenderable(data, configMap) {
        if (!data) return [];

        const sortedEntries = sortMetadataEntries(data, configMap);
        const processedEntries = sortedEntries.map(([key, value]) => [key, displayFalsyValue(value)]);

        return processedEntries.map(([key, value]) => {
            const config = configMap[key];
            const displayName = config?.displayName || key;

            return {
                key,
                displayName,
                value,
                renderedValue: <MetadataRenderer fieldName={key} value={value}/>
            };
        });
    }

    /**
     * Transforms data for table display (without JSX rendering)
     */
    static transformForTable(data, configMap) {
        if (!data) return {};

        const result = {};
        const sortedEntries = sortMetadataEntries(data, configMap);

        sortedEntries.forEach(([key, value]) => {
            result[key] = displayFalsyValue(value);
        });

        return result;
    }
}